"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterEditPage = MeterEditPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_router_dom_1 = require("react-router-dom");
var edit_classification_dialog_1 = require("../../../components/dialogs/edit-classification-dialog");
var building_1 = require("../../../features/apis/building");
var building_area_1 = require("../../../features/apis/building-area");
var meter_1 = require("../../../features/apis/meter");
var service_1 = require("../../../features/apis/service");
var hooks_1 = require("../../../store/hooks");
var change_diff_1 = require("../../../utils/change-diff");
var to_title_case_1 = require("../../../utils/to-title-case");
var meter_field_meta_1 = require("./meter-field-meta");
var meter_form_1 = require("./meter-form");
var meter_checked_by_1 = require("./meter-checked-by");
var meter_history_view_1 = require("./meter-history-view");
function MeterEditPage() {
    var _this = this;
    var _a;
    var meterId = (0, react_router_dom_1.useParams)().meterId;
    var searchParams = (0, react_router_dom_1.useSearchParams)()[0];
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _b = (0, hooks_1.useAppSelector)(function (state) { return state.auth; }), clientId = _b.clientId, userId = _b.userId;
    var initialMode = searchParams.get("mode") === "edit" ? "edit" : "view";
    var _c = (0, react_3.useState)(initialMode), mode = _c[0], setMode = _c[1];
    var _d = (0, react_3.useState)("manage"), topTab = _d[0], setTopTab = _d[1];
    var updateMeter = (0, meter_1.useUpdateMeterMutation)()[0];
    var _e = (0, meter_1.useFetchMeterQuery)(meterId || "", { skip: !meterId }), meterResponse = _e.data, isMeterLoading = _e.isLoading;
    var buildingsResponse = (0, building_1.useFetchClientBuildingsQuery)({ clientId: clientId, page: 1, limit: 100 }, { skip: !clientId }).data;
    var areasResponse = (0, building_area_1.useFetchAllClientBuildingAreasQuery)({ clientId: clientId }, { skip: !clientId }).data;
    var metersResponse = (0, meter_1.useFetchMetersQuery)({ clientId: clientId, page: 1, limit: 1000 }, { skip: !clientId }).data;
    // Meter Management Refinements: a production/bulk meter is assigned to one of the asset's services.
    var servicesResponse = (0, service_1.useFetchClientServicesQuery)({ clientId: clientId, page: 1, limit: 1000 }, { skip: !clientId }).data;
    var meter = (meterResponse === null || meterResponse === void 0 ? void 0 : meterResponse.content) || null;
    var isLoading = isMeterLoading;
    var notFound = !isLoading && !meter;
    var buildings = (0, react_3.useMemo)(function () { var _a; return ((_a = buildingsResponse === null || buildingsResponse === void 0 ? void 0 : buildingsResponse.content) === null || _a === void 0 ? void 0 : _a.buildings) || []; }, [buildingsResponse]);
    var areas = (0, react_3.useMemo)(function () { var _a; return ((_a = areasResponse === null || areasResponse === void 0 ? void 0 : areasResponse.content) === null || _a === void 0 ? void 0 : _a.buildingAreas) || []; }, [areasResponse]);
    var existingMeters = (0, react_3.useMemo)(function () {
        var _a;
        var meters = ((_a = metersResponse === null || metersResponse === void 0 ? void 0 : metersResponse.content) === null || _a === void 0 ? void 0 : _a.meters) || [];
        // serialNumber and areaName come along so a check meter's picker shows something recognisable.
        return meters.map(function (m) { return ({ _id: m._id, areaId: m.areaId, meterType: m.meterType, serialNumber: m.serialNumber, areaName: m.areaName }); });
    }, [metersResponse]);
    var serviceOptionsForForm = (0, react_3.useMemo)(function () {
        var _a;
        var services = ((_a = servicesResponse === null || servicesResponse === void 0 ? void 0 : servicesResponse.content) === null || _a === void 0 ? void 0 : _a.services) || [];
        return services
            .filter(function (sv) { return sv.isActive && !sv.deleted; })
            .map(function (sv) { return ({ key: sv._id, label: sv.name, buildingId: String(sv.buildingId), serviceType: sv.serviceType }); });
    }, [servicesResponse]);
    // Building options for the form (with IDs)
    var buildingOptionsForForm = (0, react_3.useMemo)(function () {
        // `code` is needed to compose a check meter name (MC&LCC-3.2), which is prefixed with it.
        return buildings.map(function (b) { return ({ key: b.name, label: (0, to_title_case_1.toTitleCase)(b.name), id: b._id, code: b.code }); }).sort(function (a, b) { return a.label.localeCompare(b.label); });
    }, [buildings]);
    // Area options for the form
    var areaOptionsForForm = (0, react_3.useMemo)(function () {
        return areas.map(function (a) { return ({ key: a._id, label: "".concat(a.areaNumber, " - ").concat((0, to_title_case_1.toTitleCase)(a.buildingName)), buildingId: a.buildingId }); });
    }, [areas]);
    // Edit classification dialog state — see handleMeterUpdate for the
    // promise-based handoff pattern (mirrors asset-edit / area-management).
    var _f = (0, react_3.useState)(false), isClassificationOpen = _f[0], setIsClassificationOpen = _f[1];
    var _g = (0, react_3.useState)([]), pendingChanges = _g[0], setPendingChanges = _g[1];
    var pendingPayloadRef = (0, react_3.useRef)(null);
    var pendingResolverRef = (0, react_3.useRef)(null);
    var buildPayload = function (data, classification) { return ({
        _id: meterId,
        clientId: clientId,
        editClassification: classification.classification,
        effectiveDate: classification.effectiveDate,
        effectiveTime: classification.effectiveTime,
        reason: classification.reason,
        fieldClassifications: classification.fieldClassifications,
        meterType: data.meterType,
        serialNumber: data.serialNumber,
        meterLocation: data.meterLocation,
        description: data.description,
        meterMake: data.meterMake,
        meterModel: data.meterModel,
        buildingId: data.buildingId,
        areaId: data.areaId,
        tenantId: data.tenantId,
        tenantName: data.tenantName,
        effectiveConsumptionDate: data.effectiveConsumptionDate,
        kvaRating: data.kvaRating,
        breakerSize: data.breakerSize,
        rateCard: data.rateCard,
        multiplier: data.multiplier,
        installationDate: data.installationDate,
        isManualReading: data.isManualReading,
        calibrationDate: data.calibrationDate,
        nextCalibrationDate: data.nextCalibrationDate,
        responsibleParty: data.responsibleParty,
        isActive: data.isActive,
        notes: data.notes,
        /*
         * The meter's purpose and what it is assigned to.
         *
         * These were missing from the payload entirely, so the purpose section of the form collected a
         * purpose, a service or a checked-meter list and silently discarded all of it on save — which is
         * why every meter on DEV still reads "Not set". MC&LCC-3.2 adds the check meter's own name and
         * physicality, which would have been dropped the same way.
         */
        meterPurpose: data.meterPurpose,
        serviceId: data.serviceId,
        checksMeterIds: data.checksMeterIds,
        phaseCount: data.phaseCount,
        checkMeterDescription: data.checkMeterDescription,
        checkMeterPhysicality: data.checkMeterPhysicality,
        lastModifiedBy: userId,
    }); };
    var buildMeterSnapshot = function (data) { return ({
        serialNumber: data.serialNumber,
        meterType: data.meterType,
        meterMake: data.meterMake,
        meterModel: data.meterModel,
        meterLocation: data.meterLocation,
        description: data.description,
        isActive: data.isActive,
        buildingName: meter === null || meter === void 0 ? void 0 : meter.buildingName,
        areaName: meter === null || meter === void 0 ? void 0 : meter.areaName,
        tenantName: data.tenantName,
        responsibleParty: data.responsibleParty,
        kvaRating: data.kvaRating,
        breakerSize: data.breakerSize,
        rateCard: data.rateCard,
        multiplier: data.multiplier,
        isManualReading: data.isManualReading,
        effectiveConsumptionDate: data.effectiveConsumptionDate,
        installationDate: data.installationDate,
        calibrationDate: data.calibrationDate,
        nextCalibrationDate: data.nextCalibrationDate,
        notes: data.notes,
    }); };
    var buildOriginalSnapshot = function (m) { return ({
        serialNumber: m.serialNumber,
        meterType: m.meterType,
        meterMake: m.meterMake,
        meterModel: m.meterModel,
        meterLocation: m.meterLocation,
        description: m.description,
        isActive: m.isActive,
        buildingName: m.buildingName,
        areaName: m.areaName,
        tenantName: m.tenantName,
        responsibleParty: m.responsibleParty,
        kvaRating: m.kvaRating,
        breakerSize: m.breakerSize,
        rateCard: m.rateCard,
        multiplier: m.multiplier,
        isManualReading: m.isManualReading,
        effectiveConsumptionDate: m.effectiveConsumptionDate,
        installationDate: m.installationDate,
        calibrationDate: m.calibrationDate,
        nextCalibrationDate: m.nextCalibrationDate,
        notes: m.notes,
    }); };
    var handleMeterUpdate = function (data) {
        if (!meterId || !meter)
            return Promise.resolve(false);
        var before = buildOriginalSnapshot(meter);
        var after = buildMeterSnapshot(data);
        var diff = (0, change_diff_1.computeFieldDiff)(before, after, meter_field_meta_1.METER_FIELD_META);
        if (diff.length === 0) {
            (0, react_1.addToast)({ title: "No changes", description: "Nothing to save.", color: "primary" });
            return Promise.resolve(false);
        }
        pendingPayloadRef.current = data;
        setPendingChanges(diff);
        setIsClassificationOpen(true);
        return new Promise(function (resolve) {
            pendingResolverRef.current = resolve;
        });
    };
    var submitClassifiedUpdate = function (classification) { return __awaiter(_this, void 0, void 0, function () {
        var data, resolve, response, error_1, message;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    data = pendingPayloadRef.current;
                    resolve = pendingResolverRef.current;
                    pendingPayloadRef.current = null;
                    pendingResolverRef.current = null;
                    if (!data || !resolve)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateMeter(buildPayload(data, classification)).unwrap()];
                case 2:
                    response = _b.sent();
                    if (response.success) {
                        (0, react_1.addToast)({ title: "Meter Updated", description: "Meter has been updated successfully.", color: "success" });
                        setMode("view");
                        resolve(true);
                    }
                    else {
                        (0, react_1.addToast)({ title: "Update Failed", description: response.message || "Could not update meter.", color: "danger" });
                        resolve(false);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    message = ((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.data) === null || _a === void 0 ? void 0 : _a.message) || "An error occurred while updating the meter.";
                    (0, react_1.addToast)({ title: "Update Failed", description: message, color: "danger" });
                    resolve(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var cancelClassification = function () {
        setIsClassificationOpen(false);
        var resolve = pendingResolverRef.current;
        pendingResolverRef.current = null;
        pendingPayloadRef.current = null;
        if (resolve)
            resolve(false);
    };
    var handleCancel = function () {
        if (mode === "edit") {
            setMode("view");
        }
        else {
            navigate("/dashboard/meters");
        }
    };
    var handleBack = function () {
        navigate("/dashboard/meters");
    };
    var isViewMode = mode === "view";
    var isEditMode = mode === "edit";
    if (isLoading) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "flex h-full items-center justify-center", children: (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "lg" }) }));
    }
    if (notFound) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex h-full flex-col items-center justify-center gap-4", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:bolt-circle-linear", className: "text-6xl text-gray-400" }), (0, jsx_runtime_1.jsx)("h2", { className: "text-xl font-semibold text-gray-700", children: "Meter Not Found" }), (0, jsx_runtime_1.jsx)("p", { className: "text-gray-500", children: "The meter you're looking for doesn't exist or has been deleted." }), (0, jsx_runtime_1.jsx)(react_1.Button, { color: "primary", variant: "flat", onPress: function () { return navigate("/dashboard/meters"); }, children: "Back to Meters" })] }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex h-full flex-col gap-3", children: [(0, jsx_runtime_1.jsxs)("div", { className: "rounded-xl bg-white p-4 shadow-sm md:p-6", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsxs)(react_1.Breadcrumbs, { size: "sm", children: [(0, jsx_runtime_1.jsx)(react_1.BreadcrumbItem, { onPress: function () { return navigate("/dashboard/meters"); }, children: "Meters" }), (0, jsx_runtime_1.jsx)(react_1.BreadcrumbItem, { children: isEditMode ? "Edit Meter" : "View Meter" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-3", children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-xl font-bold text-gray-800", children: isEditMode ? "Edit Meter" : "View Meter" }), (0, jsx_runtime_1.jsxs)("span", { className: "text-sm text-gray-500", children: [(meter === null || meter === void 0 ? void 0 : meter.meterId) || "#".concat(meter === null || meter === void 0 ? void 0 : meter.meterNumber), " \u2022 ", meter === null || meter === void 0 ? void 0 : meter.serialNumber] })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [isViewMode && ((0, jsx_runtime_1.jsx)(react_1.Button, { variant: "flat", color: "primary", size: "sm", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:pen-linear" }), onPress: function () { return setMode("edit"); }, children: "Edit" })), (0, jsx_runtime_1.jsx)(react_1.Button, { variant: "light", size: "sm", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:arrow-left-linear" }), onPress: handleBack, children: "Back to Meters" })] })] }), meterId && ((0, jsx_runtime_1.jsx)("div", { className: "mt-4 border-b border-gray-100", children: (0, jsx_runtime_1.jsxs)(react_1.Tabs, { "aria-label": "Meter management", variant: "underlined", color: "primary", selectedKey: topTab, onSelectionChange: function (k) { return setTopTab(String(k)); }, classNames: {
                                tabList: "gap-6",
                                tab: "px-0 h-10",
                                panel: "hidden",
                            }, children: [(0, jsx_runtime_1.jsx)(react_1.Tab, { title: (0, jsx_runtime_1.jsxs)("span", { className: "flex items-center gap-1", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:settings-linear", className: "text-base" }), "Manage"] }) }, "manage"), (0, jsx_runtime_1.jsx)(react_1.Tab, { title: (0, jsx_runtime_1.jsxs)("span", { className: "flex items-center gap-1", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:history-linear", className: "text-base" }), "History"] }) }, "history")] }) }))] }), topTab === "manage" && ((0, jsx_runtime_1.jsxs)("div", { className: "flex-1 rounded-xl bg-white p-4 shadow-sm md:p-6", children: [(0, jsx_runtime_1.jsx)(meter_form_1.MeterForm, { mode: mode, variant: "page", initialData: meter || undefined, onSubmit: handleMeterUpdate, onCancel: handleCancel, buildingOptions: buildingOptionsForForm, areaOptions: areaOptionsForForm, existingMeters: existingMeters, serviceOptions: serviceOptionsForForm, onCreateService: function (buildingId) { return navigate("/dashboard/services?create=1&buildingId=".concat(buildingId)); } }), meterId && clientId && ((0, jsx_runtime_1.jsx)("div", { className: "mt-6", children: (0, jsx_runtime_1.jsx)(meter_checked_by_1.MeterCheckedBy, { meterId: meterId, clientId: clientId }) }))] })), topTab === "history" && meterId && ((0, jsx_runtime_1.jsx)("div", { className: "rounded-xl bg-white shadow-sm", children: (0, jsx_runtime_1.jsx)(meter_history_view_1.MeterHistoryView, { meterId: meterId, showAuditLog: true }) })), (0, jsx_runtime_1.jsx)(edit_classification_dialog_1.EditClassificationDialog, { isOpen: isClassificationOpen, entityLabel: "Meter: ".concat((_a = meter === null || meter === void 0 ? void 0 : meter.serialNumber) !== null && _a !== void 0 ? _a : ""), changes: pendingChanges, onCancel: cancelClassification, onConfirm: function (classification) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                setIsClassificationOpen(false);
                                return [4 /*yield*/, submitClassifiedUpdate(classification)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); } })] }));
}
